import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/router/routes';
import NProgress from 'nprogress';
import { useRecordsStoreOutside } from '@/store/modules/records';
import 'nprogress/nprogress.css';
import { useContractStoreOutside } from '@/store/modules/contract';
import { useMedicalOrgStoreOutside } from '@/store/modules/medicalOrg';
import { setQuery, getQuery, projectStorage } from '@tencent/fd-utils';
const router = createRouter({
  // 解决 二级路径存在时，路径地址路由不匹配的问题
  // https://juejin.cn/post/7051826951463370760#heading-27
  history: createWebHistory(import.meta.env.VITE_APP_BASE_URI),
  // history: createWebHistory('./'),
  // history: createWebHistory(),
  routes,
  strict: true,
  // scrollBehavior: () => ({ left: 0, top: 0 }),
});

// 不鉴权路由：首页、建档引导页、鉴权页
// const routerWhiteList: string[] = ['mpauth', 'records-guide', 'home'];

// router.beforeResolve((_to, _from, next) => {

// });
// 复制corpId和token参数
const copyQuery = (to) => {
  const copyTo = to;
  const corpId = getQuery('corpId') || projectStorage.get('corpId');
  const token = getQuery('token') || projectStorage.get('urlToken');
  copyTo.query = { ...to.query, ...{ corpId, token } };
  copyTo.fullPath = setQuery(copyTo.query, copyTo.fullPath);
};

router.beforeEach(async (_to, _from, next) => {
  // 以下的 token 和 corpId，是为了兼容用户直接分享链接进入的情况
  // 给每个路由添加默认参数token
  copyQuery(_to);
  // const copyTo = _to;
  // if (!copyTo.query.token) {
  //   copyTo.query = { ...copyTo.query, token: projectStorage.get('urlToken') };
  //   next({ path: _to.path, query: copyTo.query });
  //   return;
  // }
  // // 给每个路由添加默认参数corpId
  // if (!copyTo.query.corpId) {
  //   copyTo.query = { ...copyTo.query, corpId: projectStorage.get('corpId') };
  //   next({ path: _to.path, query: copyTo.query });
  //   return;
  // }
  // start progress bar
  NProgress.start();
  // if (!projectStorage.get('isAuth') && !routerWhiteList.includes(_to.name as string)) {
  //   next({ name: 'mpauth', query: { callback: encodeURIComponent(`${location.pathname}${location.search}`) } });
  //   return;
  // }

  // console.log('xxx-router-before', _to, _from);
  // 建档页不能直接访问，必须存在有相关档案信息
  if (_to.path.startsWith('/records/add/') && !useRecordsStoreOutside().records) {
    next({ name: 'sign-list', replace: true });
  }
  // 签约页不能不带参进入，且不存在档案信息
  if (
    _to.name === 'contract-index' &&
    !(_to.query?.profileId && _to.query?.relation) &&
    !useRecordsStoreOutside().records
  ) {
    next({ name: 'sign-list', replace: true });
  }
  // 选择签约信息的3步：机构、团队、服务，必须有患者信息
  if (_to.path.startsWith('/contract/select/') && !useContractStoreOutside()?.profileId) {
    next({ name: 'sign-list', replace: true });
  }
  // 来源于 /records 或 /contract 路由，去向不是这两个路由
  // 表示来源于建档签约流程，但当前正好跳出流程
  if (
    (_from.path.startsWith('/records/') || _from.path.startsWith('/contract/')) &&
    (!_to.path.startsWith('/records/') || _to.path === '/records/auth') &&
    !_to.path.startsWith('/contract/') &&
    !_to.path.startsWith('/agreement')
  ) {
    useRecordsStoreOutside().resetStore();
    useContractStoreOutside().resetStore();
    useMedicalOrgStoreOutside().resetStore();
  }

  next();
});

router.afterEach((_to, _from) => {
  // finish progress bar
  NProgress.done();
  // console.log('xxx-router-after', _to, _from);
});

export { router };
